module.exports = __webpack_public_path__ + "img/machine.1.0.0_202207131815.png";